export default "__VITE_ASSET__B3nLnmz8__"